import { useNavigate } from "react-router-dom";

import SEO from "../../../components/pages/SEO/SEO";

import AboutHero from "../../../components/pages/About/AboutHero";
import AboutFounder from "../../../components/pages/About/AboutFounder";
import AboutVisionMission from "../../../components/pages/About/AboutVisionMission";
import AboutAchievements from "../../../components/pages/About/AboutAchievements";
import AboutTestimonials from "../../../components/pages/About/AboutTestimonials";
import AboutCTA from "../../../components/pages/About/AboutCTA";

import {
  ABOUT_STATS,
  TESTIMONIALS,
  FOUNDER_INFO,
} from "../../../constants/pages/about/aboutConstants";

import { getAboutSEO } from "../../../utils/page/seo/aboutSeo";

export default function About() {
  const navigate = useNavigate();

  return (
    <div className="bg-white">
      <SEO {...getAboutSEO()} />

      <AboutHero />

      <AboutFounder
        founder={FOUNDER_INFO}
      />

      <AboutVisionMission />

      <AboutAchievements
        stats={ABOUT_STATS}
      />

      <AboutTestimonials
        testimonials={TESTIMONIALS}
      />

      <AboutCTA
        onPostProperty={() =>
          navigate("/post-property")
        }
        onGoHome={() =>
          navigate("/")
        }
      />
    </div>
  );
}